import { common } from "../../shared/utils/UtilSaga";
import ApiService from "../../shared/services/ApiService";
import { call, fork, put, takeLatest, select } from "redux-saga/effects";

import {
  GET_REPORT,
  IS_LOADING_REPORT,
  FETCH_REPORT,
  REMOVE_REPORT,
  FAILED_GROUPORDER_PDF,
  FETCH_GROUPORDER_DOWNLOAD,
} from "./Report.constant";

function* workerGetReportData(action) {
  try {
    yield put({ type: IS_LOADING_REPORT, payload: true });
    const response = yield call(
      ApiService.report.getReportData,
      action?.payload
    );
    if (response) {
      yield put({ type: GET_REPORT, payload: response });
    }
  } catch (error) {
    console.error("Error fetching report data:", error);
    yield put({ type: REMOVE_REPORT, payload: error.message });
  } finally {
    yield put({ type: IS_LOADING_REPORT, payload: false });
  }
}
function* workerGetGroupOrderPdf(action) {
  const { history, ...payload } = action.payload;
  try {
    yield call(ApiService.report.getGroupOrderPdf, payload);
  } catch (error) {
    yield put({ type: FAILED_GROUPORDER_PDF, payload: error.message });
  } finally {
    yield put({ type: IS_LOADING_REPORT, payload: false });
  }
}
function* watchReport() {
  yield takeLatest(FETCH_REPORT, common(workerGetReportData));
}
function* watchGroupOrderPdf() {
  yield takeLatest(FETCH_GROUPORDER_DOWNLOAD, common(workerGetGroupOrderPdf));
}

export default function reportWatchers() {
  return [fork(watchReport), fork(watchGroupOrderPdf)];
}
